import {
  Box,
  Checkbox,
  Fieldset,
  Flex,
  Grid,
  MultiSelect,
  Select,
  TextInput,
} from "@mantine/core";
import { DateTimePicker } from "@mantine/dates";
import { IconCalendarMonth } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { repositoryPos } from "../../../../../../_base/_const/_constVar";
import { SelectListItemBase } from "../../../../../../_base/model/_base/SelectListItemBase";
import { MessageResponse } from "../../../../../../model/MessageResponse";
import { tblPromotionDetailModel } from "../../../../../../model/TblPromotion";

const GeneralInformation = ({
  dataPromotionDetail,
}: {
  dataPromotionDetail: tblPromotionDetailModel | undefined;
}) => {
  useEffect(() => {
    getType11();
  }, [dataPromotionDetail]);
  const [selectType, setTypeSelect] = useState<SelectListItemBase[]>([]);
  const getType11 = async () => {
    var resType = await repositoryPos.get<MessageResponse<any[]>>(
      "/api/v1/TblPromotion/type"
    );
    if (resType?.httpStatusCode === 200 && resType.data) {
      setTypeSelect([
        ...resType.data,
        {
          att1: "",
          att2: "",
          att3: 0,
          att4: 0,
          att5: null,
          disabled: false,
          group: null,
          selected: false,
          text: "Deal sốc",
          value: "4",
        },
      ]);
    }
  };

  const _styleGrid = { base: 12, md: 6, lg: 2 };

  return (
    <Box h={"max-content"}>
      <Fieldset
        legend="Thông tin chung"
        display={"flex"}
        style={{ flexDirection: "column", gap: "10px" }}
      >
        <Grid>
          <Grid.Col span={_styleGrid}>
            <TextInput
              label="Mã CTKM"
              placeholder="Nhập Mã CTKM"
              readOnly
              value={dataPromotionDetail?.code || ""}
            />
          </Grid.Col>
          {/* <Grid.Col span={{ base: 6, md: 1.5, lg: 1.5 }}>
            <NumberInput
              label="Thứ tự ưu tiên"
              min={0}
              size="xs"
              readOnly
              value={dataPromotionDetail?.priority || ""}
            />
          </Grid.Col> */}

          <Grid.Col span={_styleGrid}>
            <TextInput
              label="Người lập"
              readOnly
              value={dataPromotionDetail?.createBy || ""}
              w={"100%"}
            />
          </Grid.Col>
          <Grid.Col span={_styleGrid}>
            <TextInput
              label="Chính sách khuyến mại"
              readOnly
              value={
                selectType.filter(
                  (x) => x.value === dataPromotionDetail?.type
                )[0]?.text || ""
              }
            />
          </Grid.Col>
          <Grid.Col span={_styleGrid}>
            <DateTimePicker
              label="Thời gian bắt đầu đếm ngược"
              placeholder="Thời gian bắt đầu đếm ngược"
              locale="vi"
              rightSection={<IconCalendarMonth size={14} />}
              value={
                dataPromotionDetail?.countDownDate
                  ? new Date(dataPromotionDetail?.countDownDate)
                  : null
              }
              readOnly
            />
          </Grid.Col>
          <Grid.Col span={_styleGrid}>
            <DateTimePicker
              readOnly
              label="Hiệu lực từ ngày"
              placeholder="Hiệu lực từ ngày"
              minDate={new Date()}
              rightSection={<IconCalendarMonth size={14} />}
              value={
                dataPromotionDetail?.effDate
                  ? new Date(dataPromotionDetail?.effDate)
                  : null
              }
            />
          </Grid.Col>

          <Grid.Col span={_styleGrid}>
            <DateTimePicker
              readOnly
              label="Đến ngày"
              placeholder="Đến ngày"
              rightSection={<IconCalendarMonth size={14} />}
              value={
                dataPromotionDetail?.expDate
                  ? new Date(dataPromotionDetail?.expDate)
                  : null
              }
            />
          </Grid.Col>
          <Grid.Col span={_styleGrid}>
            <TextInput
              label="Trạng thái"
              placeholder="Trạng thái"
              w={"100%"}
              readOnly
              value={
                dataPromotionDetail?.approveStatus === "2"
                  ? "Đã duyệt"
                  : dataPromotionDetail?.approveStatus === "3"
                  ? "Dừng duyệt"
                  : dataPromotionDetail?.approveStatus === "4"
                  ? "Từ chối"
                  : dataPromotionDetail?.approveStatus === "5"
                  ? "Hủy duyệt"
                  : "Chưa duyệt"
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 2 }}>
            <MultiSelect
              readOnly
              label="Chọn phương thức thanh toán"
              placeholder="Vui lòng chọn phương thức thanh toán"
              nothingFoundMessage="Không có dữ liệu"
              data={[
                { value: "all", label: "Tất cả" },
                {
                  value: "offline",
                  label: "Thanh toán khi nhận hàng",
                },
                {
                  value: "online",
                  label: "Thanh toán bằng chuyển khoản",
                },
                {
                  value: "card",
                  label: "Thanh toán bằng thẻ quốc tế Visa, Master",
                },
              ]}
              searchable
              value={
                dataPromotionDetail?.listPaymentMethod &&
                Array.isArray(dataPromotionDetail?.listPaymentMethod)
                  ? dataPromotionDetail?.listPaymentMethod
                  : []
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <Select
              label="Áp dụng"
              placeholder="Chọn trình duyệt áp dụng"
              data={[
                { label: "Áp dụng đồng thời POS và Web", value: "1" },
                { label: "Chỉ áp dụng trên POS", value: "2" },
                { label: "Chỉ áp dụng trên Web", value: "3" },
              ]}
              value={
                dataPromotionDetail?.attribute3
                  ? dataPromotionDetail?.attribute3
                  : ""
              }
              readOnly
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6 }}>
            <TextInput
              label="Tên CTKM"
              placeholder="Tên CTKM"
              readOnly
              withAsterisk
              value={dataPromotionDetail?.note || ""}
            />
          </Grid.Col>
        </Grid>
        <Grid>
          <Grid.Col span={12}>
            <TextInput
              label="Ghi chú"
              placeholder="Nhập ghi chú"
              readOnly
              value={dataPromotionDetail?.attribute5 || ""}
            />
          </Grid.Col>
        </Grid>
        <Grid mt={5}>
          <Grid.Col span={12}>
            <Flex justify={"start"} align={"center"} gap={"md"}>
              <Checkbox
                label="Áp dụng đồng thời CTKM khác"
                checked={dataPromotionDetail?.ismultiple}
                readOnly
              />
              {dataPromotionDetail?.type === "4" && (
                <Checkbox
                  label="Mỗi số điện thoại chỉ được áp dụng 1 lần"
                  checked={dataPromotionDetail?.attribute6 === "true"}
                  readOnly
                />
              )}
            </Flex>
          </Grid.Col>
        </Grid>
      </Fieldset>
    </Box>
  );
};

export default GeneralInformation;
